import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import type { BgpCommunities } from '@ipfabric/utils/settings/types/types';
import { BgpSettings } from 'components/BgpSettings/BgpSettings';
import { type UseFormReturn, useWatch } from 'react-hook-form';
import z from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';

type BgpSettingsFieldValues = {
  bgps: BgpCommunities[];
};

const BgpSettingsFormAdapter = (props: {
  form: UseFormReturn<BgpSettingsFieldValues>;
}) => {
  const bgps = useWatch({
    control: props.form.control,
    name: 'bgps',
  });
  return (
    <BgpSettings
      bgps={bgps}
      onBgpsChange={(bgps) => {
        props.form.setValue('bgps', bgps, { shouldDirty: true });
      }}
    />
  );
};

export const bgpSettings: FormSnippet<
  DiscoverySettingsObject,
  BgpSettingsFieldValues
> = {
  render: ({ form }) => <BgpSettingsFormAdapter form={form} />,

  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.bgps = model.bgps ?? [];
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.bgps = transformedValues.bgps;
  },
  schema: z.object({
    bgps: z.any(),
  }) as z.Schema<BgpSettingsFieldValues>,
};
